import { ExpandMore } from "@mui/icons-material";
import { Box, css, styled } from "@mui/system";
import { SortDirection } from "@tanstack/react-table";
import { IconButton } from "@mui/material";

export const TableContainer = styled("div")`
  overflow: auto hidden;
`;

export const Table = styled("table", {
  shouldForwardProp: (prop) => prop !== "fetching",
})<{ fetching?: boolean }>`
  border-spacing: 0;
  width: 100%;
  border-radius: 16px;
  ${(props) =>
    props.fetching &&
    css`
      opacity: 0.5;
      cursor: wait;
      tbody {
        pointer-events: none;
      }
    `}

  thead {
    height: 56px;
    user-select: none;
    background-color: ${({ theme }) => theme.palette.backgrounds.tableHeader};
    box-shadow: 0 0 10px ${({ theme }) => theme.palette.neutral900};
    z-index: 2;
    position: relative;
  }

  th {
    color: ${({ theme }) => theme.palette.neutral200};
    white-space: nowrap;
    padding: 4px 10px;
  }

  // not a proper breakpoint but this is where the table starts to crumble and have the horizontal scroll
  @media (max-width: 400px) {
    th {
      padding: 4px 7px;
      #marketplace-table__sorted-icon {
        margin-right: -6px;
        margin-left: -2px;
      }
    }
  }

  td {
    @media (min-width: ${({ theme }) => theme.breakpoints.values.md}px) {
      padding: 12px 15px;
      height: 95px;
    }
    background: ${({ theme }) => theme.palette.backgrounds.tableRow};
    color: ${({ theme }) => theme.palette.neutral100};
    padding: 10px 5px;
    white-space: nowrap;
    border-bottom: 1px solid ${({ theme }) => theme.palette.neutral700};
    text-align: center;
  }

  tbody {
    tr:last-child {
      td {
        border-bottom: 0;
      }
    }
  }
`;

export const SortIcon = styled(ExpandMore, {
  shouldForwardProp: (prop) => prop !== "isSorted",
})<{ isSorted: false | SortDirection }>`
  transition: all 0.1s linear;

  ${({ isSorted }) =>
    !isSorted
      ? css`
          visibility: none;
          opacity: 0;
          margin-left: -24px !important;
          margin-right: 0 !important;
        `
      : isSorted === "asc"
        ? css`
            transform: rotate(180deg);
          `
        : ``}
`;

export const SmallSelectWrapper = styled("div")`
  min-width: 84px;

  .zig-react-select {
    &__control {
      min-height: 36px !important;
      margin-top: 0;
      margin-bottom: 0;
      padding: 0 !important;
    }
  }
`;

export const HeaderIconButton = styled(IconButton)`
  margin-left: -20px;
`;

export const HeaderBox = styled(Box)`
  min-height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SortBox = styled("div", {
  shouldForwardProp: (prop) => prop !== "canSort",
})<{ canSort: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  ${({ canSort }) =>
    canSort &&
    css`
      cursor: pointer;
    `}
`;
